<template>
  <div v-if="post">
    <div class="c-msg" v-if="!post.completed_at">
      {{ hasErr ? $T('post.invited.friend.err_msg') : $T('page.member.info.approval.friend.msg') }}
    </div>
    <div class="c-flex jc c w100 c-action">
      <div class="c-img" :class="leTbS ? 'c-cover-80' : 'c-cover-160'">
        <post-avatar :size="leTbS ? 80 : 160" :postId="post.id" :name="cm ? cm.nickname : ''" />
      </div>
      <div class="c-explain">
        <div class="c-com"><community-chip-s :cid="fcid" :wCss="leSp ? 'sm' : 'lm'" /></div>
        <div class="c-name" :style="maxNameWidth">{{ cm ? cm.nickname : ' ' }}</div>
        <div v-if="hasErr" class="c-role f-danger">{{ errMsg }}</div>
        <div v-else-if="post.completed_at" class="c-role">
          <div class="clr-gray--text">{{ $T('post.accept.completed') }}</div>
          <div>
            <span class="clr-primary--text" v-if="post.result.r == 1">{{ $T('button.approval') }}</span>
            <span class="clr-danger--text" v-if="post.result.r == 0">{{ $T('button.rejection') }}</span>
            <span class="clr-danger--text" v-if="post.result.r == -1">{{ $T('post.err.status-changed') }}</span>
          </div>
        </div>
        <div v-else class="c-role f-danger">{{ $T('common.member_status.pending') }}</div>
      </div>
    </div>
    <!-- Issue #12: 会員専用の承認/却下アクションはゲスト(覗いてみる)に描画しない（多重防御。主因は BE guest 描画＋X-GUEST で API がゲスト可視性） -->
    <div v-if="!post.completed_at && !isGuest" class="c-flex jc c w100 c-action">
      <template v-if="memberCountChecked">
        <template v-if="hasErr">
          <v-btn
            :loading="loading"
            :disabled="post.completed_at || loading"
            class="c-confirm-btn"
            :class="disabled ? 'elevation-1' : 'elevation-6'"
            @click="onCheckClicked"
            color="clr-btn"
            round
            dark
            depressed
          >
            {{ $T('post.btn.confirm') }}
          </v-btn>
        </template>
        <template v-else-if="memberCountExceed">
          <v-tooltip bottom>
            <v-btn slot="activator" color="clr-secondary" outline @click.native="onApproveClicked" disabled>{{
              $T('button.approval')
            }}</v-btn>
            <span>{{ $T('page.member.approve.over_limit') }}</span>
          </v-tooltip>
        </template>
        <template v-else>
          <v-btn
            color="clr-secondary"
            outline
            @click.native="onApproveClicked"
            :loading="accept && loading"
            :disabled="!isActive || loading"
            >{{ $T('button.approval') }}</v-btn
          >
          <v-btn
            color="clr-danger"
            outline
            @click.native="onRejectClicked"
            :loading="!accept && loading"
            :disabled="!isActive || loading"
            >{{ $T('button.rejection') }}</v-btn
          >
        </template>
      </template>
    </div>

    <msg-dialog ref="msg_dialog" />
  </div>
</template>

<script>
import postDetailPlugin from '../../utils/plugin/postDetailPlugin';
import { mapActions } from 'vuex';
import UTILS from '../../utils/utils';
import { CONST } from '../../constant';
import App from '../../utils/App';
import {
  getPostForInvite,
  answerInvitationFriendAccept,
  answerInvitationDecline,
  answerInvitationChecked,
} from '../../api/post';
import selectCover from '../common/SelectCover.vue';

import CommunityApi from '../../api/community';

import postAvatar from '../../components/common/PostAvatar.vue';

export default {
  mixins: [postDetailPlugin],
  components: {
    'post-avatar': postAvatar,
    'select-cover': selectCover,
  },
  props: {
    initPost: { type: Object, required: true },
  },
  data: function() {
    return {
      post: null,
      c: null,
      loading: false,
      accept: false,
      apiErrors: {},
      showExplain: false,
      memberCountChecked: false,
      memberCountExceed: false,
      cm: null,
    };
  },
  mounted() {
    this.setup(this.initPost);
  },
  watch: {
    initPost(n, o) {
      this.setup(n);
    },
  },
  computed: {
    acceptable() {
      return this.completed_atthis.options;
    },
    completeSuccessfuly() {
      return !this.post.result.e && !!this.post.completed_at;
    },
    errType() {
      if (!this.post) return 0;
      return this.post.result.e || (this.isPast(this.post.expire_at) ? 3 : 0) || this.post.options.inviteErr || 0;
    },
    hasErr() {
      return !!this.errType && this.errType != 4;
    },
    errMsg() {
      switch (this.errType) {
        case 1:
          return $T('post.invited.err.invite_code');
        case 2:
          return $T('post.invited.err.invite_disabled');
        case 3:
          return $T('post.invited.err.expired');
        case 4:
          return $T('post.invited.err.used');
        case 5:
          return $T('page.member.invite.err.registered.friend.msg');
        case 6:
          return $T('page.member.invite.err.entried.friend.title');
        case 7:
          return $T('page.member.invite.err.no_condition.msg');
        case 10:
          return $T('page.member.invite.err.member_limit.msg');
        case 11:
          return $T('page.member.invite.err.friend_limit.self');
        case 12:
          return $T('page.member.invite.err.friend_limit.other');

        case 99:
          return $T('page.member.invite.err.banned.friend.msg');
        case 100:
          return $T('page.member.invite.err.dissolved.friend.title');
      }
      return $T('error_mess.server_error');
    },
    maxNameWidth() {
      var w = 300;
      if (this.geMax) w = 562;
      else if (this.gePc) w = this.w - 550 - 207;
      else if (this.leSp) w = this.w - 102;
      else if (this.leTbS) w = this.w - 177;
      else if (this.leTb) w = this.w - 250 - 207;
      return `max-width: ${w}px;`;
    },
    isActive() {
      return !this.$utils.isPostCompleted(this.post);
    },
    fcid() {
      return this.$store.state.community.fcid;
    },
  },
  methods: {
    ...mapActions({
      refreshPostById: 'refreshPostById',
      refreshCommunity: 'refreshCommunity',
    }),
    async setup(post) {
      this.loading = false;
      this.accept = false;
      this.apiErrors = {};
      try {
        this.post = await getPostForInvite(post.id);
      } catch (e) {
        console.error('failed to get init post data', e);
        this.errGetData();
        return;
      }

      const cmid = this.post.content.creator_to_cmid;

      const cmForView = await App.toCmForView(cmid, this.fcid, { type: CONST.APP_TYPE.POST, id: this.post.id }, true);
      this.cm = cmForView.cm;

      if (!post.completed_at) {
        this.memberCountChecked = false;
        this.memberCountExceed = false;

        const response = await CommunityApi.isMemberCountExceeded(this.cid);
        try {
          this.memberCountChecked = true;
          this.memberCountExceed = response.result;
        } catch (e) {
          console.error('failed to get posts data', e);
          this.errGetData();
        }
      }

      if (cmForView.requireRefreshAppParam) {
        const result = await App.refreshFriendMap({
          type: CONST.APP_TYPE.POST,
          id: this.post.id,
          cid: this.post.community_id,
        });
        await App.getGroupsAndCmsFromServer(this.fcid);
        const cmForViewServer = await App.toCmForView(
          cmid,
          this.fcid,
          { type: CONST.APP_TYPE.POST, id: this.post.id },
          true
        );
        this.cm = cmForViewServer.cm;
      }
    },
    fmtExplain(v) {
      return markdown(v);
    },
    getMessage(fieldName) {
      return this.apiErrors[fieldName] && this.apiErrors[fieldName][this.inputValue]
        ? this.apiErrors[fieldName][this.inputValue]
        : this.errors.collect(fieldName);
    },
    onApproveClicked() {
      if (this.isGuest) return;

      this.accept = true;
      this.loading = true;
      this._callApi(answerInvitationFriendAccept);
    },
    onRejectClicked() {
      if (this.isGuest) return;

      this.accept = false;
      this._callApi(answerInvitationDecline, null);
    },
    onCheckClicked() {
      if (this.isGuest) return;

      var data = new FormData();
      data.append('errType', this.errType);
      this._callApi(answerInvitationChecked, data);
    },
    async _callApi(method, data) {
      this.loading = true;
      try {
        const post = await method(this.post.id, data);
        this.loading = false;
        this.post = post;
        this.$emit('modified', post);
      } catch (error) {
        if (error.type == 'MemberCountExceed') {
          this.post.options.inviteErr = 10;
        } else if (error.option && error.option.type == 'COMPLETED') {
          this.post.is_complete = true;
          this.post.completed_at = error.option.t;
          this.post.result = error.option.r;
          this.$emit('modified', this.post);
        }
        console.error('failed to answer post data for pid[' + this.post.id + ']', error);
      } finally {
        this.loading = false;
      }
    },
    onMsgClosed() {
      this.$router.push({ name: 'topHome', params: { id: this.selectedCommunity.id } });
    },
  },
};
</script>

<style scoped>
.c-action {
  margin: 10px 0px 10px 0px;
}
.le-tbs .c-action {
  margin: 0 0px 10px 0px;
}
.c-confirm-btn {
  min-width: 200px;
}
.c-img {
  margin-top: 11px;
}
.le-tbs .c-img {
  margin: 0 auto;
}
.c-img img {
  margin: 0 auto;
}
.c-explain {
  flex-grow: 1;
  padding-left: 24px;
  align-self: center;
}
.le-sp .c-explain {
  padding-left: 0px;
}
.c-name {
  text-align: left;
  font-size: 20px;
  font-weight: 600;
  padding: 8px 0 !important;
  color: rgba(0, 0, 0, 0.87);
}
.c-role {
  text-align: left;
  font-size: 16px;
  padding-bottom: 10px;
}
.c-role.f-danger {
  color: #e64a19 !important;
}
.c-explain .c-msg {
  white-space: initial;
  size: 12px;
  color: rgba(0, 0, 0, 0.72);
  padding: 8px 0;
}
.c-err-msg {
  margin: 10px 0px 5px 0px;
  font-size: 18px;
}
.c-com {
  margin: 10px 0px 20px 0px;
}
.le-tbs .c-com {
  margin: 10px 0px;
}
.c-tm {
  font-size: 14px;
}
.c-tm .v-icon {
  font-size: 19px !important;
}
.c-tm.e {
  margin-bottom: 3px;
}
.c-tm.b {
  color: #e64a19;
}
.c-comp {
  margin: 25px 0 30px 0;
}
.le-tbs .c-comp {
  margin: 10px 0 20px 0;
}
.c-comp-msg {
  font-size: 18px;
  padding-top: 15px;
}
.c-prof {
  margin: 20px auto 25px auto;
  width: 75%;
}
.c-prof-name {
  margin-top: 24px;
}
.c-condition {
  padding: 8px 0;
}
.c-condition .c-ttl {
  color: rgba(0, 0, 0, 0.72);
  font-size: 16px;
  font-weight: 600;
}
.c-condition .c-cond-content {
  text-align: left;
}
.c-condition .c-attr {
  margin-left: 10px;
  color: rgba(0, 0, 0, 0.72);
  font-size: 12px;
}
.c-condition .c-val {
  font-size: 16px;
  font-weight: 600;
}
.c-complete-text {
  font-size: 14px;
}
.c-result {
}
</style>
